import moment from "moment";

const METHOD_LABELS = {
  phone_otp: "Phone OTP",
  password: "Password",
  google: "Google",
  apple: "Apple",
};

/**
 * Last app login of a user/driver; older accounts that never logged in since tracking began show "Not recorded".
 */
export default function LastLogin({ user, showMethod = true }) {
  if (!user?.lastLoginAt) {
    return (
      <span className="text-muted" style={{ fontSize: "0.85rem" }}>
        Not recorded
      </span>
    );
  }

  const at = moment(user.lastLoginAt);
  const method = METHOD_LABELS[user.lastLoginMethod];

  return (
    <span title={at.format("MMM DD, YYYY, hh:mm A")}>
      {at.format("MM/DD/YYYY, hh:mm A")}
      {showMethod && method ? (
        <span className="text-muted d-block" style={{ fontSize: "0.8rem" }}>
          via {method} · {at.fromNow()}
        </span>
      ) : null}
    </span>
  );
}
